export const useStyles = (theme) => ({
  root: {
    padding: 20,
    minHeight: "50vh",
  },
  paper: {
    padding: 10,
    display: "flex",
    flexDirection: "column",
  },
  divider: {
    height: 25,
    borderRadius: 20,
  },
});
